"use strict";
'kiwi public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var IRC_COLOURS = ['#FFFFFF',
// 00 White
'#000000',
// 01 Black
'#00007F',
// 02 Navy
'#009300',
// 03 Green
'#FF0000',
// 04 Red
'#7F0000',
// 05 Maroon
'#9C009C',
// 06 Purple
'#FC7F00',
// 07 Orange
'#FFFF00',
// 08 Yellow
'#00FC00',
// 09 Lime
'#009393',
// 10 Teal
'#00FFFF',
// 11 Aqua
'#0000FC',
// 12 Blue
'#FF00FF',
// 13 Magenta
'#7F7F7F',
// 14 Dark Grey
'#D3D3D3' // 15 Light Grey
];
var _default2 = exports.default = {
  props: {
    buffer: {
      default: null
    },
    ircinput: {
      default: null
    },
    activeFormats: {
      default: function _default() {
        return {
          bold: false,
          italic: false,
          underline: false,
          fgColour: -1,
          bgColour: -1
        };
      }
    }
  },
  data: function data() {
    return {
      colours: IRC_COLOURS
    };
  },
  methods: {
    setColour: function setColour(colourIdx) {
      this.$emit('format', 'colour', colourIdx);
    },
    setBgColour: function setBgColour(colourIdx) {
      this.$emit('format', 'bgcolour', colourIdx);
    },
    resetStyle: function resetStyle() {
      this.$emit('format', 'reset');
    },
    toggleBold: function toggleBold() {
      this.$emit('format', 'bold');
    },
    toggleItalic: function toggleItalic() {
      this.$emit('format', 'italic');
    },
    toggleUnderline: function toggleUnderline() {
      this.$emit('format', 'underline');
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["inputtools"]) window._kiwi_exports["components"]["inputtools"] = {};
window._kiwi_exports["components"]["inputtools"]["TextStyle"]
window._kiwi_exports.components.inputtools.TextStyle = exports.default ? exports.default : exports;
